import {
  Button,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Box } from "@mui/system";
import React from "react";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SlidingPanel from "react-sliding-side-panel";
interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const Vehicles: React.FC<Props> = ({ open_status, attrName, value_update }) => {
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [vehiclesstatus, setVehiclesStatus] = React.useState(false);
  const [annualIncome, setAnnualIncome] = React.useState<
    number | string | Array<number | string>
  >(300000);
  const [gender, setGender] = React.useState("");
  const [maritalStatus, setMaritalStatus] = React.useState("");
  const [relation, setRelation] = React.useState("");
  const [age, setAge] = React.useState("");
  const [dob, setDob] = React.useState<Date | null>(
    new Date("2014-08-18T21:11:54")
  );
  const [vehicleType, setVehicleType] = React.useState("");
  const [policyEXpiryDate, setPolicyExpiryDate] = React.useState<Date | null>(
    null
  );
  const [makeModel, setMakeModel] = React.useState("");
  const [fuelType, setFuelType] = React.useState("");
  const [variant, setVariant] = React.useState("");
  const [regDate, setRegDate] = React.useState<Date | null>(null);
  const [previousInsurer, setPreviousInsurer] = React.useState("");

  let vehicleType_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  let makeModel_data = [
    { label: "Hyundai i10", value: "Hyundai i10" },
    { label: "Hyundai Grand i10 NIOS", value: "Hyundai Grand i10 NIOS" },
  ];
  let fuelType_data = [
    { key: "Diesel", value: "Diesel" },
    { key: "Petrol", value: "Petrol" },
  ];
  let variant_data = [
    { key: "Diesel", value: "Diesel" },
    { key: "Petrol", value: "Petrol" },
  ];
  let previousInsurer_data = [
    { key: "Diesel", value: "Diesel" },
    { key: "Petrol", value: "Petrol" },
  ];

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  const [open, setOpen] = React.useState(false);
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  return (
    <Grid container spacing={0} className="addedVehicles">
      <Grid md={9} lg={7}>
        <Grid container alignItems="center" spacing={3}>
          <Grid xs={6}>
            <h3 className="mb-0">Vehicles</h3>
          </Grid>
          <Grid xs={6} className="text-right">
            <Link
              className="greenBtn addfile"
              underline="none"
              onClick={() => {
                setVehiclesStatus(true);
              }}
            >
              Add Vehicle
            </Link>

            <SlidingPanel
              type={"right"}
              isOpen={vehiclesstatus}
              size={75}
              panelClassName="slidingPanel"
              backdropClicked={() => setVehiclesStatus(false)}
            >
              <Box
                className={
                  open_status == true ? "modalInner show" : "modalInner"
                }
              >
                <Grid container spacing={3} alignItems="center">
                  <Grid xs={9}>
                    <h4 className="mb-5 mt-4 text-left">Add New Vehicles</h4>
                  </Grid>
                  <Grid xs={3}>
                    <Link
                      className="close-button"
                      onClick={() => {
                        setVehiclesStatus(false);
                      }}
                    />
                  </Grid>
                </Grid>

                <div className="scrollable_area">
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <Typography>
                        <Grid container spacing={3} justifyContent="center">
                          <Grid xs={8} className="inputField">
                            <TextField
                              fullWidth
                              id="outlined-basic"
                              label=""
                              variant="outlined"
                              className="regno"
                              placeholder="DL01AS5552"
                            />
                          </Grid>
                          <Grid xs={6} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Vehicle Type"
                              value={vehicleType}
                              attrName={setVehicleType}
                              value_update={updateMasterState}
                              dropdown_data={vehicleType_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <DatePicker
                              class_name="inputField"
                              title="Policy Expiry Date"
                              value={policyEXpiryDate}
                              attrName={setPolicyExpiryDate}
                              value_update={updateMasterState}
                              error_message="Please enter DOB"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Make &amp; Model"
                              attrName={setMakeModel}
                              value={makeModel}
                              value_update={updateMasterState}
                              data={makeModel_data}
                              error_message="Please select Make and Model"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Fuel Type"
                              value={fuelType}
                              attrName={setFuelType}
                              value_update={updateMasterState}
                              dropdown_data={fuelType_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={12} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Variant"
                              value={variant}
                              attrName={setVariant}
                              value_update={updateMasterState}
                              dropdown_data={variant_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <DatePicker
                              class_name="inputField"
                              title="Reg. Date"
                              value={regDate}
                              attrName={setRegDate}
                              value_update={updateMasterState}
                              error_message="Please enter Reg. Date"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Previous Insurer"
                              value={previousInsurer}
                              attrName={setPreviousInsurer}
                              value_update={updateMasterState}
                              dropdown_data={previousInsurer_data}
                              warn_status={false}
                            />
                          </Grid>
                          {/* <Grid
                                  xs={12}
                                  className="ctaBtn"
                                  style={{ textAlign: "center" }}>
                                  <Button className="submitBtn">
                                    Submit Details
                                  </Button>
                                </Grid> */}
                        </Grid>
                      </Typography>
                    </Grid>
                  </Grid>
                </div>

                <Grid container spacing={2}>
                  <Grid
                    xs={12}
                    style={{ textAlign: "center", position: "relative" }}
                    className="ctaBtn"
                  >
                    <Button
                      variant="contained"
                      className="submitBtn fixedbtn"
                      onClick={() => {}}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </SlidingPanel>
          </Grid>
          <Grid md={12}>
            <h5>Four Wheeler</h5>
            <Box className="vehicleDetails">
              <span className="vehicleIcon">
                <img src="./../images/four_wheeler_icon.svg" alt="vehicle" />
              </span>
              <span className="vehicleName">
                <h6>Maruti Suzuki Alto VXi</h6>
                <p>Petrol, 800 cc</p>
              </span>
              <span className="actionBtns">
                <Link className="redBtn delete" underline="none">
                  Remove
                </Link>
                <Link className="orangeBtn reload" underline="none">
                  Renew
                </Link>
              </span>
              <div className="regDetails">
                <span>
                  <p>Vehicle Number</p>
                  <h6>PB01AB1234</h6>
                </span>
                <span>
                  <p>Policy Expiry</p>
                  <h6>12 Dec,2022</h6>
                </span>
                <span className="text-right">
                  <p>Policy Status</p>
                  <h6 className="expired">Expired</h6>
                </span>
              </div>
            </Box>
          </Grid>
          <Grid md={12}>
            <h5>Two Wheeler</h5>
            <Box className="vehicleDetails">
              <span className="vehicleIcon">
                <img src="./../images/two_wheeler_icon.svg" alt="vehicle" />
              </span>
              <span className="vehicleName">
                <h6>Honda Active 5G</h6>
                <p>160 cc</p>
              </span>
              <span className="actionBtns">
                <Link className="redBtn delete" underline="none">
                  Remove
                </Link>
                <Link className="orangeBtn reload" underline="none">
                  Renew
                </Link>
              </span>
              <div className="regDetails">
                <span>
                  <p>Vehicle number</p>
                  <h6>PB01AB1234</h6>
                </span>
                <span>
                  <p>Policy Expiry</p>
                  <h6>12 Dec,2022</h6>
                </span>
                <span className="text-right">
                  <p>Policy Status</p>
                  <h6 className="active">Active</h6>
                </span>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Vehicles;
